import styled from 'styled-components';

export const OccupancyWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spaces.space5};
  margin-bottom: 10px;
`;

export const OccupancyInfo = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: ${({ theme }) => theme.spaces.space2};
  }
`;
